var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionReject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.0625C4.5525 17.0625 0.9375 13.4475 0.9375 9C0.9375 4.5525 4.5525 0.9375 9 0.9375C13.4475 0.9375 17.0625 4.5525 17.0625 9C17.0625 13.4475 13.4475 17.0625 9 17.0625ZM9 2.0625C5.175 2.0625 2.0625 5.175 2.0625 9C2.0625 12.825 5.175 15.9375 9 15.9375C12.825 15.9375 15.9375 12.825 15.9375 9C15.9375 5.175 12.825 2.0625 9 2.0625Z",
    fill: "#F04438"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87749 11.6845C6.73499 11.6845 6.59249 11.632 6.47999 11.5195C6.26249 11.302 6.26249 10.942 6.47999 10.7245L10.725 6.47953C10.9425 6.26203 11.3025 6.26203 11.52 6.47953C11.7375 6.69703 11.7375 7.05703 11.52 7.27453L7.27499 11.5195C7.16999 11.632 7.01999 11.6845 6.87749 11.6845Z",
    fill: "#F04438"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1225 11.6845C10.98 11.6845 10.8375 11.632 10.725 11.5195L6.47999 7.27453C6.26249 7.05703 6.26249 6.69703 6.47999 6.47953C6.69749 6.26203 7.05749 6.26203 7.27499 6.47953L11.52 10.7245C11.7375 10.942 11.7375 11.302 11.52 11.5195C11.4075 11.632 11.265 11.6845 11.1225 11.6845Z",
    fill: "#F04438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionReject);
export default __webpack_public_path__ + "static/media/action-reject.416f94f45e6d993da491c0cc82614514.svg";
export { ForwardRef as ReactComponent };